// extracted by mini-css-extract-plugin
module.exports = {"bg":"Spinner_bg__1AbkE","bgWithColor":"Spinner_bgWithColor__1M_n8","spinnerDown":"Spinner_spinnerDown__2goag","wrap":"Spinner_wrap__CDPq0"};